import React from "react";
import Box from "@mui/material/Box";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormLabel from "@mui/material/FormLabel";
import useMediaQuery from "@mui/material/useMediaQuery";
import { Button, Divider, IconButton, Tooltip } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useSelector, useDispatch } from "react-redux";
import * as actions from "../../../../actions/actions";
import dayjs from "dayjs";
import { isSameDay } from "date-fns";
import { PickersDay } from "@mui/x-date-pickers";
import { ALERT_SCREENS } from "../../../global/constants";

const FinishTimeHeaderBox = (props) => {
  const dispatch = useDispatch();
  const compactTablet = useMediaQuery("(max-width:1024px)"); // tablet & below → narrower fields
  const [eventId, seteventId] = React.useState(0);
  const [today, setToday] = React.useState(dayjs(new Date()));
  const [sessionsDate, setSessionsDate] = React.useState(dayjs(new Date()));
  const [disableFields, setDisableFields] = React.useState(false);
  const [raceSessionId, setRaceSessionId] = React.useState("");

  const penalties = useSelector(
    (state) => state.allPenalties.allPenalties.data,
  );
  const initialEvent = useSelector((state) => state.eventData.eventData.data);
  const [event, setEvent] = React.useState(initialEvent);
  const initialEventList = useSelector(
    (state) => state.eventList.eventList.data,
  );
  const raceSessions = useSelector(
    (state) => state.raceSessionData.raceSessionData.data,
  );
  const initialRaceDates = useSelector(
    (state) => state.raceSeriesData.raceSeriesData.data,
  );
  const club = useSelector((state) => state.clubData.clubData.data);
  const [highlightedDays, setHighlitedDays] = React.useState([]);

  const queryParameters = new URLSearchParams(window.location.search);
  const eventIdQ = queryParameters.get("id");
  const raceSessionIdQ = queryParameters.get("raceSessionId");
  const dateValQ = queryParameters.get("dateVal");
  const queryParams = [eventIdQ, raceSessionIdQ, dateValQ];
  const paramExist = queryParams.every(
    (value) => value !== null && value !== undefined,
  );

  const retainDate = useSelector(
    (state) => state.selectedDate.selectedDate.data,
  );

  React.useEffect(() => {
    if (initialEventList && initialEventList?.length > 0 && eventIdQ) {
      let selectedEvent = initialEventList.find((x) => x.eventId == eventIdQ);
      seteventId(eventIdQ);
      setEvent(selectedEvent);
      props.setEventId(eventIdQ);
      if (selectedEvent) {
        props?.setCaseOTBEntrant(selectedEvent?.type == 2 ? true : false);
      }
      let sessionDT = dayjs(dateValQ).format("YYYY-MM-DD");
      setSessionsDate(sessionDT);
      setToday(dayjs(sessionDT));
      props.setDate(sessionDT);
    }
  }, [initialEventList, eventIdQ, dateValQ]);

  React.useEffect(() => {
    if (initialEvent && initialEvent?.eventId && !eventIdQ) {
      seteventId(initialEvent?.eventId);
      setEvent(initialEvent);
      props.setEventId(initialEvent);
      if (initialEvent) {
        props?.setCaseOTBEntrant(initialEvent?.type == 2 ? true : false);
      }
      dispatch(actions.selectedEventData(initialEvent));
      dispatch(actions.fetchRaceDaysSeries(initialEvent?.eventId));
    }
  }, [initialEvent, eventIdQ]);

  React.useEffect(() => {
    if (
      initialEventList?.length > 0 &&
      !eventIdQ &&
      (!initialEvent?.eventId ||
        !initialEventList.some((e) => e.eventId === initialEvent?.eventId))
    ) {
      seteventId(initialEventList[0]?.eventId);
      setEvent(initialEventList[0]);
      props.setEventId(initialEventList[0] || { eventId: "" });
      dispatch(actions.selectedEventData(initialEventList[0]));
      dispatch(actions.fetchRaceDaysSeries(initialEventList[0]?.eventId));
    }
  }, [initialEvent, initialEventList, eventIdQ]);

  React.useEffect(() => {
    if (retainDate && retainDate?.date !== null) {
      setToday(dayjs(retainDate));
      setSessionsDate(dayjs(retainDate).format("YYYY-MM-DD"));
      props.setDate(dayjs(retainDate).format("YYYY-MM-DD"));
    } else {
      setToday(dayjs(new Date()));
    }
  }, [retainDate]);

  React.useEffect(() => {
    if (raceSessions && raceSessions.length > 0 && raceSessionIdQ) {
      let raceSessionObj = raceSessions.filter(
        (rc) => rc.raceSessionId == raceSessionIdQ,
      )[0];
      let isOverNightRace = raceSessionObj.raceSessionsDetailList
        .map((ev) => ev.options.o === "Y")
        .includes(true);
      props.setIsPlace(false);
      if (raceSessionObj != null) {
        if (raceSessionObj.raceSessionsDetailList.length > 0) {
          if (
            raceSessionObj.raceSessionsDetailList[0].series.resultOptions
              .length > 0 &&
            (raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
              .resultBy[0] === "Place" ||
              raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
                .resultBy[0] === "Custom-Place")
          ) {
            props.setIsPlace(true);
          }
        }
      }
      dispatch(actions.emptyRaceNotes(raceSessionObj.raceSessionId));
      props.setRaceSessions(raceSessionObj.raceSessionId, isOverNightRace);
      props.setRaceSessionNotes(
        raceSessionObj ? raceSessionObj.sessionNotes : "",
      );
      setRaceSessionId(raceSessionIdQ);
    }
  }, [raceSessions?.length, raceSessionIdQ]);

  React.useEffect(() => {
    if (initialRaceDates.length > 0) {
      setHighlitedDays(initialRaceDates.map((x) => x.raceDate.split("T")[0]));
    } else {
      setHighlitedDays([]);
    }
  }, [initialRaceDates]);

  const CustomDay = (props) => {
    const matchedStyles = highlightedDays.reduce((a, v) => {
      const date = new Date(props.day);
      return isSameDay(date, v) ? { backgroundColor: "#90EE90" } : a;
    }, {});
    return <PickersDay {...props} sx={{ ...matchedStyles }} />;
  };

  React.useEffect(() => {
    if (club?.type) {
      dispatch(actions.fetchEventList(0, club?.type));
    }
    dispatch(actions.fetchAllPenalties());
    sessionStorage.setItem("screen", ALERT_SCREENS.finishTimes);
  }, [club?.type]);

  React.useEffect(() => {
    props.setPenalties(penalties);
  }, [penalties]);

  React.useEffect(() => {
    if (eventId > 0) {
      dispatch(actions.fetchRaceDaysSeries(eventId));
    }
    if (eventId > 0 && sessionsDate) {
      let sessionDT = dayjs(sessionsDate).format("YYYY-MM-DD");
      setDisableFields(true);
      dispatch(actions.fetchRaceSession(eventId, sessionDT)).finally(() => {
        setDisableFields(false);
        setRaceSessionId(0);
      });
    }
  }, [eventId, sessionsDate]);

  const handleRaceSessionUpdate = (e) => {
    let raceSessionObj = raceSessions.filter(
      (rc) => rc.raceSessionId === e.target.value,
    )[0];
    let isOverNightRace = raceSessionObj.raceSessionsDetailList
      .map((ev) => ev.options.o === "Y")
      .includes(true);
    props.setIsPlace(false);
    if (raceSessionObj != null) {
      if (raceSessionObj.raceSessionsDetailList.length > 0) {
        if (
          raceSessionObj.raceSessionsDetailList[0].series.resultOptions.length >
            0 &&
          (raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
            .resultBy[0] === "Place" ||
            raceSessionObj.raceSessionsDetailList[0].series.resultOptions[0]
              .resultBy[0] === "Custom-Place")
        ) {
          props.setIsPlace(true);
        }
      }
    }
    dispatch(actions.emptyRaceNotes(raceSessionObj.raceSessionId));
    props.setRaceSessions(raceSessionObj.raceSessionId, isOverNightRace);
    props.setRaceSessionNotes(
      raceSessionObj ? raceSessionObj.sessionNotes : "",
    );
    setRaceSessionId(e.target.value);
  };

  const handleEventUpdate = (e) => {
    const selectedEvent = initialEventList.find(
      (ev) => ev.eventId === e.target.value,
    );
    if (selectedEvent) {
      props?.setCaseOTBEntrant(selectedEvent?.type == 2 ? true : false);
    }
    seteventId(e.target.value);
    setEvent(initialEventList.find((x) => x.eventId == e.target.value));
    props.setEventId(initialEventList.find((x) => x.eventId == e.target.value));
    dispatch(
      actions.selectedEventData(
        initialEventList.find((x) => x.eventId == e.target.value),
      ),
    );
    props.setRaceSessions("");
  };

  const handleSessionDateChange = (e) => {
    setToday(dayjs(e));
  };

  const handleDateUpdate = (value) => {
    let sessionDT = dayjs(value).format("YYYY-MM-DD");
    setSessionsDate(sessionDT);
    props.setDate(sessionDT);
    dispatch(actions.selectedDate(sessionDT));
    props.setRaceSessions("");
    setRaceSessionId("");
  };

  const handleKeyDown = (key) => {
    if (key === "Enter") {
      if (!today || !dayjs(today).isValid()) return;
      let sessionDT = dayjs(today).format("YYYY-MM-DD");
      setSessionsDate(sessionDT);
      props.setDate(sessionDT);
      dispatch(actions.selectedDate(sessionDT));
      props.setRaceSessions("");
      setRaceSessionId("");
    }
  };

  const handleDateBlur = () => {
    if (!today || !dayjs(today).isValid()) return;
    let sessionDT = dayjs(today).format("YYYY-MM-DD");
    if (sessionDT === sessionsDate) return;
    setSessionsDate(sessionDT);
    props.setDate(sessionDT);
    dispatch(actions.selectedDate(sessionDT));
    props.setRaceSessions("");
    setRaceSessionId("");
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-end",
        gap: compactTablet ? 0.75 : 1.5,
        flexWrap: "wrap",
        width: "100%",
      }}
    >
      {/* Event */}
      <Box sx={{ width: compactTablet ? 135 : 175, minWidth: 0 }}>
        <FormLabel className="ty-uppercase-label">Event</FormLabel>
        <Select
          size="small"
          displayEmpty
          value={event?.eventId || initialEventList[0]?.eventId || ""}
          onChange={handleEventUpdate}
          disabled={paramExist || disableFields}
          renderValue={(val) => {
            const ev = initialEventList.find((e) => e.eventId === val);
            return ev ? ev.eventName : "Select Event";
          }}
          sx={{
            width: "100%",
            height: 34,
            fontSize: 12,
            "& .MuiSelect-select": {
              py: "6px",
              overflow: "hidden",
              textOverflow: "ellipsis",
            },
          }}
        >
          {initialEventList.map((ev) => (
            <MenuItem key={ev.eventId} value={ev.eventId} sx={{ fontSize: 12 }}>
              {ev.eventName}
            </MenuItem>
          ))}
        </Select>
      </Box>

      {/* Date */}
      <Box sx={{ width: compactTablet ? 135 : 175, minWidth: 0 }}>
        <FormLabel className="ty-uppercase-label">Date</FormLabel>
        <Box className="datePickerField">
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              format="YYYY-MM-DD"
              value={today}
              onChange={handleSessionDateChange}
              onAccept={handleDateUpdate}
              disabled={paramExist || disableFields}
              slots={{
                openPickerIcon: CalendarTodayOutlinedIcon,
                day: CustomDay,
              }}
              desktopModeMediaQuery="@media (min-width: 0px)"
              slotProps={{
                textField: {
                  onKeyDown: (event) => handleKeyDown(event.key),
                  onBlur: handleDateBlur,
                  size: "small",
                  sx: {
                    width: "100%",
                    "& .MuiInputBase-root": {
                      height: 34,
                      fontSize: 12,
                      pr: "4px",
                    },
                    "& .MuiInputBase-input": { padding: "0 0 0 6px" },
                    "& .MuiInputAdornment-root": { ml: 0, mr: "12px" },
                    "& .MuiIconButton-root": { p: "2px" },
                  },
                },
              }}
            />
          </LocalizationProvider>
        </Box>
      </Box>

      {/* Session */}
      <Box sx={{ width: compactTablet ? 135 : 175, minWidth: 0 }}>
        <FormLabel className="ty-uppercase-label">Session</FormLabel>
        <Select
          size="small"
          displayEmpty
          value={raceSessionIdQ || raceSessionId}
          onChange={handleRaceSessionUpdate}
          disabled={paramExist || disableFields}
          renderValue={(val) => {
            const rs = (raceSessions || []).find(
              (s) => s.raceSessionId === val,
            );
            return rs ? rs.sessionName : "Select Session";
          }}
          sx={{
            width: "100%",
            height: 34,
            fontSize: 12,
            "& .MuiSelect-select": { py: "6px" },
          }}
        >
          {raceSessions != undefined &&
            raceSessions.map((raceSession) => (
              <MenuItem
                key={raceSession.raceSessionId}
                value={raceSession.raceSessionId}
                sx={{ fontSize: 12 }}
              >
                {raceSession.sessionName}
              </MenuItem>
            ))}
        </Select>
      </Box>

      {/* Action buttons: Start Time, Session Notes, Import/Export, Fullscreen */}
      {props.showActions && (
        <>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexWrap: "nowrap",
              gap: 1.25,
              ml: "auto",
            }}
          >
            {/* Start Time */}
            {compactTablet ? (
              <Tooltip title="Start Time">
                <IconButton
                  size="small"
                  onClick={() => props.onOpenDrawer("start")}
                  sx={{
                    border: "1px solid #dceaf0",
                    borderRadius: 1,
                    color: "var(--ty-primary-color, #356dad)",
                  }}
                >
                  <AccessTimeIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            ) : (
              <Button
                className="ty_secondary_btn"
                size="small"
                startIcon={<AccessTimeIcon />}
                onClick={() => props.onOpenDrawer("start")}
                sx={{ border: "1px solid #dceaf0" }}
              >
                Start Time
              </Button>
            )}

            {/* Session Notes */}
            {compactTablet ? (
              <Tooltip title="Session Notes">
                <IconButton
                  size="small"
                  onClick={() => props.onOpenDrawer("notes")}
                  sx={{
                    border: "1px solid #dceaf0",
                    borderRadius: 1,
                    color: "var(--ty-primary-color, #356dad)",
                  }}
                >
                  <DescriptionOutlinedIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            ) : (
              <Button
                className="ty_secondary_btn"
                size="small"
                startIcon={<DescriptionOutlinedIcon />}
                onClick={() => props.onOpenDrawer("notes")}
                sx={{ border: "1px solid #dceaf0" }}
              >
                Session Notes
              </Button>
            )}

            {/* Import / Export */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                border: "1px solid #dceaf0",
                borderRadius: 1,
              }}
            >
              <Tooltip title="Import CSV">
                <IconButton
                  size="small"
                  onClick={props.onImportClick}
                  disabled={!props.hasEntrants}
                  sx={{ borderRadius: 0 }}
                >
                  <FileUploadOutlinedIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
              <Divider orientation="vertical" flexItem />
              <Tooltip title="Export">
                <IconButton
                  size="small"
                  onClick={props.onExport}
                  disabled={!props.hasFinishedEntrants}
                  sx={{ borderRadius: 0 }}
                >
                  <FileDownloadOutlinedIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            </Box>

            {/* Fullscreen */}
            <Tooltip
              title={props.isFullscreen ? "Exit full screen" : "Full screen"}
            >
              <IconButton
                size="small"
                onClick={props.onToggleFullscreen}
                sx={{ border: "1px solid #dceaf0", borderRadius: 1 }}
              >
                {props.isFullscreen ? (
                  <FullscreenExitIcon sx={{ fontSize: 18 }} />
                ) : (
                  <FullscreenIcon sx={{ fontSize: 18 }} />
                )}
              </IconButton>
            </Tooltip>
          </Box>
        </>
      )}
    </Box>
  );
};

export default FinishTimeHeaderBox;
